import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12df0759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { locusAoiAdd, queryLocusAoiBaseInfo, locusAddorupdate } from '@/api'
import { CODE_ENUM, LOCUS_DIRECTION_TYPE } from '@/common/enum'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'
import { useDeviceStore } from '@/stores/device'
import { isEmpty } from 'lodash'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'locus-info',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const authStore = useAuthStore()
const deviceStores = useDeviceStore()

const t = i18n.global.t




const formRef: any = ref<FormInstance>()

const form = ref({
  aoiName: '',
  deviceBindIds: [],
  aoiDirectionCode: LOCUS_DIRECTION_TYPE.IN,
  addAoiAlarmStrategy: [],
})

const title = computed(() => {
  return props.data?.id ? t('D_LOCUS.editTitle') : t('D_LOCUS.newTitle')
})

const validateAuthCode = (code: string) => {
  return authStore.resources.includes(code)
}

const rules: any = ref({
  aoiName: [
    { required: true, message: t('D_LOCUS.enterPla'), trigger: 'blur' },
  ],
  aoiDirectionCode: [
    { required: true, message: t('D_LOCUS.enterPla'), trigger: 'blur' },
  ],
})

const loading = ref(false)
watch(
  props,
  () => {
    if (props.visible) {
      loading.value = true
      deviceStores.queryDeviceOps()
      loading.value = false

      if (props.data?.id) {
        toQueryLocusAoiDevice()
      }
    }
  },
  {
    deep: true,
  }
)

const toQueryLocusAoiDevice = async () => {
  const res: any = await queryLocusAoiBaseInfo({
    aoiId: props.data?.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { aoiDirectionCode, aoiDeviceList, aoiName } = res.data
    form.value.deviceBindIds = (aoiDeviceList || []).map(
      (item: any) => item.deviceBindId
    )
    form.value.aoiName = aoiName
    form.value.aoiDirectionCode = aoiDirectionCode
  }
}

const submitLoading = ref(false)
const submit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { aoiName, deviceBindIds, aoiDirectionCode } = form.value
      submitLoading.value = true

      if (props.data?.id) {
        const res: any = await locusAddorupdate({
          aoiName,
          deviceBindIds,
          aoiId: props.data?.id,
          aoiDirectionCode,
        }).finally(() => {
          submitLoading.value = false
        })
        if (res?.code === CODE_ENUM.SUCCESS) {
          ElMessage.success(t('D_LOCUS.editSuccess'))
          cancel()
          $emit('success')
        }
      } else {
        const res: any = await locusAoiAdd({
          aoiName,
          deviceBindIds,
          aoiDirectionCode,
          addAoiAlarmStrategy: isEmpty(form.value.addAoiAlarmStrategy)
            ? false
            : true,
          ...props.data,
        }).finally(() => {
          submitLoading.value = false
        })
        if (res?.code === CODE_ENUM.SUCCESS) {
          ElMessage.success(t('D_LOCUS.newSuccess'))
          cancel()
          $emit('success')
        }
      }
    }
  })
}

const cancel = () => {
  $emit('update:visible', false)
  $emit('success')
  formRef.value.resetFields()
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "model-value": props.visible,
      title: _unref(title),
      "close-on-click-modal": false,
      "before-close": cancel,
      class: "locus-info-wrapper",
      width: 480
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: cancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            submitLoading: submitLoading.value,
            type: "primary",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.btnYes')), 1)
            ]),
            _: 1
          }, 8, ["submitLoading"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          "label-width": "80px",
          rules: rules.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('D_LOCUS.labelAoiName'),
              prop: "aoiName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.aoiName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.aoiName) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "50"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('D_LOCUS.labelRelativeDevice'),
              prop: "deviceBindIds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  clearable: "",
                  multiple: "",
                  modelValue: form.value.deviceBindIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.deviceBindIds) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceStores).deviceOps, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.label,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('D_LOCUS.geoDiretion'),
              prop: "aoiDirectionCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.value.aoiDirectionCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.aoiDirectionCode) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: _unref(LOCUS_DIRECTION_TYPE).IN,
                      name: "type"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.typeIn')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(LOCUS_DIRECTION_TYPE).OUT,
                      name: "type"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.typeOut')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_radio, {
                      label: _unref(LOCUS_DIRECTION_TYPE).IN_AND_OUT,
                      name: "type"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.typeInOut')), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!props.data.id && validateAuthCode('3-1'))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "addAoiAlarmStrategy",
                  "label-width": 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: form.value.addAoiAlarmStrategy,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.addAoiAlarmStrategy) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox, {
                          label: "checked",
                          style: {"width":"300px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('D_LOCUS.alarmTip')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title"])
  ]))
}
}

})